import { render, staticRenderFns } from "./InvestorProfileNote.vue?vue&type=template&id=4a6c6344&scoped=true"
import script from "./InvestorProfileNote.vue?vue&type=script&lang=js"
export * from "./InvestorProfileNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c6344",
  null
  
)

export default component.exports